let Backbone_Icon_List;
let noun_modal;
let noun_user;
let url_to_array;

Backbone_Icon_List = require("./backbone_iconlist").default;

noun_modal = require("./noun_modal").default;

noun_user = require("../helpers/noun_user").default;

url_to_array = require("../helpers/url_to_array").default;

class Accounts {
    constructor(props) {
        $(document).ready(() => {
            let $iconsDownloaded;
            let $iconsFlagged;
            let $iconsPending;
            let $iconsPurchased;
            let $iconsUploaded;
            let authentication;
            let closeInformationModal;
            let domain;
            let downloads_url;
            let flagged_url;
            let list;
            let on_finish;
            let on_load;
            let page;
            let pending_url;
            let purchased_url;
            let share;
            let share_modal;
            let uploads_url;
            let user_uploads_template;
            let username;
            domain = url_to_array;
            page = domain[3];
            if (page === "dashboard") {
                username = noun_user.username;
            } else {
                username = url_to_array[3];
            }
            share_modal = {
                type: "share",
                style: "full-blur",
                authenticate: false
            };
            on_finish = () =>
                $(".close-button").on("click", e => {
                    e.preventDefault();
                    return noun_modal.dismiss();
                });
            share = noun_modal.init(
                share_modal,
                $("body"),
                "click",
                (on_load = on_finish),
                (authentication = false),
                "a.share"
            );
            if ($(".infinite-page").length > 0) {
                $iconsUploaded = $("#icons-uploaded");
                if ($iconsUploaded.length > 0) {
                    uploads_url = `//${url_to_array[2]}/${username}/uploads/json/`;
                    if ($("#handlebar-template-uploads").length > 0) {
                        user_uploads_template = $(
                            "#handlebar-template-uploads"
                        );
                        uploads_url = `//${url_to_array[2]}/dashboard/uploads/json/`;
                    }
                    list = new Backbone_Icon_List(
                        "#icons-uploaded",
                        uploads_url,
                        2,
                        user_uploads_template,
                        72
                    );
                }
                $iconsDownloaded = $("#icons-downloaded");
                if ($iconsDownloaded.length > 0) {
                    downloads_url = `//${url_to_array[2]}/${username}/downloads/json/`;
                    list = new Backbone_Icon_List(
                        "#icons-downloaded",
                        downloads_url,
                        2,
                        void 0,
                        72
                    );
                }
                $iconsPurchased = $("#icons-purchased");
                if ($iconsPurchased.length > 0) {
                    purchased_url = `//${url_to_array[2]}/${username}/purchases/json`;
                    list = new Backbone_Icon_List(
                        "#icons-purchased",
                        purchased_url,
                        2
                    );
                }
                $iconsFlagged = $("#flagged-uploads");
                if ($iconsFlagged.length > 0) {
                    flagged_url = `//${url_to_array[2]}/${username}/uploads/flagged/json/`;
                    if ($("#handlebar-template-uploads").length > 0) {
                        user_uploads_template = $(
                            "#handlebar-template-uploads"
                        );
                    }
                    list = new Backbone_Icon_List(
                        "#flagged-uploads",
                        flagged_url,
                        2,
                        user_uploads_template,
                        72
                    );
                }
                $iconsPending = $("#pending-uploads");
                if ($iconsPending.length > 0) {
                    if ($("#handlebar-template-uploads").length > 0) {
                        user_uploads_template = $(
                            "#handlebar-template-uploads"
                        );
                    }
                    pending_url = `//${url_to_array[2]}/${username}/uploads/pending/json`;
                    list = new Backbone_Icon_List(
                        "#pending-uploads",
                        pending_url,
                        2,
                        user_uploads_template,
                        72
                    );
                }
            }
            $("body").on("click", ".more-information", function(e) {
                let contextIcon;
                let contextUrl;
                e.preventDefault();
                contextIcon = $(this).data("icon-id");
                contextUrl = $(this).data("url");
                return $.ajax({
                    url: contextUrl,
                    method: "GET",
                    success(data, status, xhr) {
                        console.log(data);
                        $("body").append(data);
                        return $("#information-modal").addClass("visible");
                    },
                    error() {
                        return console.log("Something went wrong");
                    }
                });
            });
            $("body").on("click", ".close-information-modal", e => {
                e.preventDefault();
                return closeInformationModal();
            });
            closeInformationModal = () => {
                $("#information-modal").removeClass("visible");
                return setTimeout(() => $("#information-modal").remove(), 100);
            };
            $("body").on("click", ".flip-card", function(e) {
                let parent;
                e.preventDefault();
                parent = $(this).parents("li.icon");
                return parent.addClass("flipped");
            });
            $("body").on("click", ".nevermind", function(e) {
                let parent;
                e.preventDefault();
                parent = $(this).parents("li.icon");
                return parent.removeClass("flipped");
            });
            $("body").on("click", ".delete-icon", function(e) {
                let contextIcon;
                let contextUrl;
                let parent;
                e.preventDefault();
                console.log("trying");
                contextIcon = $(this).data("icon-id");
                contextUrl = $(this).data("url");
                parent = $(this).parents("li.icon");
                console.log(parent);
                return $.ajax({
                    url: contextUrl,
                    method: "POST",
                    data: {
                        icon_id: contextIcon
                    },
                    success(data, status, xhr) {
                        parent.addClass("remove");
                        parent.fadeOut(300);
                        return setTimeout(() => parent.remove(), 500);
                    },
                    error() {
                        return console.log("Something went wrong");
                    }
                });
            });
            share_modal = {
                type: "share",
                style: "full-blur",
                authenticate: false
            };
            on_finish = () =>
                $(".close-button").on("click", e => {
                    e.preventDefault();
                    return noun_modal.dismiss();
                });
            return (share = noun_modal.init(
                share_modal,
                $("body"),
                "click",
                (on_load = on_finish),
                (authentication = false),
                "button.share"
            ));
        });
    }
}

export default Accounts;
